import * as $ from "jquery";
import { Grid } from 'ag-grid-community';
import Handlebars from "Handlebars";

export default class SearchCustomersComponent {
    constructor() {
        this.componentSelector = ".ecom-carts";
        this.instance = this;
        this.grid = null;
        this.modalTemplateSelector = "#cart-modal-template";
        this.modalTemplate;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#query').keypress(function (e) {
            var key = e.which;
            if (key == 13)
            {
                instance.searchCarts(instance);
                return false;
            }
        }); 

        const modalTemplate = $(this.modalTemplateSelector).html();
        if (modalTemplate !== undefined) {
            this.modalTemplate = Handlebars.compile(modalTemplate);
        }
    }

    searchCarts(instance) {
        let query = $('#query').val();

        if (query == "") {
            bootbox.alert("Du måste ange ett sökord.");
            return;
        }

        axios({
            method: 'post',
            url: "/carts/searchbyquery",
            data: { query: query }
        }).then(function (response) {
            console.log(response.data);
            instance.renderSearchResult(instance, JSON.parse(response.data));
        }).catch(function (response) {
            console.log(response);
            bootbox.alert("Inga varukorgar matchade sökningen.");
        });
    }

    buttonRenderer(params) {
        console.log(params)
        var button = document.createElement('button');
        button.innerHTML = 'Visa';
        button.addEventListener('click', function () {
            params.context.loadModal(params.data.Id, params.data.UserId, params.data.MarketId, params.data.Site, params.context);
        });
        return button;
    }

    loadModal(guid, userId, marketId, site, instance) {
        axios({
            method: 'post',
            url: "/carts/cartbyid",
            data: { guid: guid, userId: userId, marketId: marketId, site: site}
        }).then(function (response) {
            instance.showModal(JSON.parse(response.data), instance);
        }).catch(function (response) {
        });
    }

    showModal(data, instance) {
        $('#cart-modal').html(instance.modalTemplate(data));
        setTimeout("$('#edit-modal').modal('show');", 10);

        console.log(data);
    }

    renderSearchResult(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    { headerName: 'Kundnummer', field: 'CustomerNumber', width: 150 },
                    { headerName: 'Site', field: 'Site', width: 150 },
                    { headerName: 'Antal artiklar', field: 'ItemsCount', width: 150 },
                    {
                        headerName: "",
                        field: 'Id',
                        cellRenderer: instance.buttonRenderer,
                        width: 120,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }
}